var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebIconsComo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aba04607-6570-4b19-a9c2-181ee7daad85{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:19.86px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "abaaf155-1931-4694-80f4-4cb8518747b9",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.63,34.83a25.28,25.28,0,0,1,25.28,25.29V339.88a25.28,25.28,0,0,1-25.28,25.29H83.37a25.28,25.28,0,0,1-25.28-25.29V60.12A25.28,25.28,0,0,1,83.37,34.83H316.63m0-19.86H83.37A45.19,45.19,0,0,0,38.23,60.12V339.88A45.19,45.19,0,0,0,83.37,385H316.63a45.19,45.19,0,0,0,45.14-45.15V60.12A45.19,45.19,0,0,0,316.63,15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.98,
    y: 88.48,
    width: 35.24,
    height: 35.24,
    rx: 10.99
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.98,
    y: 276.26,
    width: 35.24,
    height: 35.24,
    rx: 10.99
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.98,
    y: 93.85,
    width: 153.29,
    height: 24.14,
    rx: 12.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.98,
    y: 283.6,
    width: 153.29,
    height: 24.14,
    rx: 12.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.74,
    y: 188.12,
    width: 129.53,
    height: 22.99,
    rx: 11.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "aba04607-6570-4b19-a9c2-181ee7daad85",
    points: "93.14 199.26 111.59 218.34 148.93 182.45"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIconsComo);
export default __webpack_public_path__ + "static/media/web-icons_como.b378d521bdb72b72e6a0a2a2971e2d72.svg";
export { ForwardRef as ReactComponent };